import { render, staticRenderFns } from "./Lights.vue?vue&type=template&id=4cba9d5b"
import script from "./Lights.vue?vue&type=script&lang=js"
export * from "./Lights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports